module.exports = "https://img.zhijierongxing.com/saas/img/finish_mark.29bc6ddc.png";